/**
 * Подстановка значений в перевод без HTML-экранирования.
 *
 * i18next по умолчанию заменяет в подставляемом значении служебные знаки HTML их обозначениями, и
 * дробная черта («100.0 / 100»), кавычки и амперсанд названия доходят до экрана обозначением, а не
 * знаком. Разметки в таких переводах нет — выводимый текст экранирует сам React, поэтому второе
 * экранирование только портит текст.
 *
 * Применять к переводам, в которые подставляются данные и ввод пользователя; для переводов с
 * разметкой (`<Trans>`) — не применять.
 */
export const RAW_INTERPOLATION = { interpolation: { escapeValue: false } } as const;
